import { axiosInstance } from '../../api/init';
import { urlBase64ToUint8Array } from './utils';

export const subscribeUser = async () => {
  try {
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
      console.log('Push notifications not supported');
      return;
    }

    if (!import.meta.env.VITE_VAPID_PUBLIC_KEY) {
      console.log('Missing key');
      return;
    }

    const registration = await navigator.serviceWorker.register('/sw.js');

    await Notification.requestPermission();

    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(
        import.meta.env.VITE_VAPID_PUBLIC_KEY,
      ),
    });

    await axiosInstance.post('/api/push/subscribe', subscription);
  } catch (error) {
    console.error('Error subscribeUser: ', error);
  }
};
